"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _mapAddressNew = _interopRequireDefault(require("../mapAddressNew"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapAddressesCollection = function mapAddressesCollection(accountData, separateEmail) {
  var _accountData$addresse, _accountData$addresse2;
  return (_accountData$addresse = accountData === null || accountData === void 0 ? void 0 : (_accountData$addresse2 = accountData.addresses) === null || _accountData$addresse2 === void 0 ? void 0 : _accountData$addresse2.map(function (address) {
    var _address$companyName, _address$vatId;
    return {
      id: address.id + "",
      isDefaultShipping: !!address.default_shipping,
      isDefaultBilling: !!address.default_billing,
      fields: _objectSpread({}, (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, address), {}, {
        isCompany: address.company !== undefined,
        firstName: address.firstname,
        lastName: address.lastname,
        email: !separateEmail ? accountData.email : separateEmail,
        companyName: (_address$companyName = address.companyName) !== null && _address$companyName !== void 0 ? _address$companyName : "",
        vatId: (_address$vatId = address.vatId) !== null && _address$vatId !== void 0 ? _address$vatId : "",
        street: Array.isArray(address.street) ? address.street[0] : address.street,
        postalCode: address.postcode,
        phone: address.telephone,
        city: address.city,
        country: [{
          id: address.country_id
        }]
      })))
    };
  })) !== null && _accountData$addresse !== void 0 ? _accountData$addresse : [];
};
var _default = mapAddressesCollection;
exports["default"] = _default;